import { Component, ElementRef, ViewChild } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ProgressCircleComponent } from '../progress';

@Component({
  selector: 'app-scrollable-content',
  templateUrl: './scrollable-content.component.html',
  styleUrls: ['./scrollable-content.component.scss'],
  standalone: true,
  imports: [AngularSvgIconModule, ProgressCircleComponent],
})
export class ScrollableContentComponent {
  @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  scrollPercentage: number = 0;

  scrollTop() {
    const element = this.scrollableDiv.nativeElement;
    element.scrollTop = 0;
    this.scrollPercentage = 0;
  }

  onScroll() {
    const element = this.scrollableDiv.nativeElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight - element.clientHeight;
    this.scrollPercentage = (scrollTop / scrollHeight) * 100;
    // Check the scroll state
    if (element.scrollTop === 0) {
      // console.log('Scrolled to the top');
    } else if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      // console.log('Scrolled to the bottom');
    } else {
      // console.log('Scrolling in between');
    }
  }
}
